import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {RpcState} from "../../../util/RpcState";
import {useRpcSender} from "../../../RpcSender";
import {GetFulfillmentStatusRequest, GetFulfillmentStatusResponse} from "../../../compiled";

/**
 * Gets details about a stripe session from the server.
 */
export const useStripeFulfillmentRpc = () => {

  const rpcSender = useRpcSender();

  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});
  const [response, setResponse] = useState<GetFulfillmentStatusResponse>();

  const send = (request: GetFulfillmentStatusRequest) => {

    
    setRpcState({state: 'pending'})
    rpcSender.send('get_fulfillment_status', GetFulfillmentStatusRequest.encode(request).finish())
        .then(bytes => {
          const response = GetFulfillmentStatusResponse.decode(bytes);
          setResponse(response);
          setRpcState({state: 'success'});
        })
        .catch(e => {
          setRpcState({state: 'error', message: e.message});
        })

  }

  return {send, rpcState, response}
};